export const ACTION_SAVE_ACTION_REQUEST = "ACTION_SAVE_ACTION_REQUEST";
export const ACTION_SAVE_ACTION_SUCCESSFUL = "ACTION_SAVE_ACTION_SUCCESSFUL";
export const ACTION_SAVE_ACTION_ERROR = "ACTION_SAVE_ACTION_ERROR";

export const ENUM_GET_ACTIONS_REQUEST = "ENUM_GET_ACTIONS_REQUEST";
export const ENUM_GET_ACTIONS_SUCCESSFUL = "ENUM_GET_ACTIONS_SUCCESSFUL";
export const ENUM_GET_ACTIONS_ERROR = "ENUM_GET_ACTIONS_ERROR";

export const LINKS_GET_LINKS_REQUEST = "LINKS_GET_LINKS_REQUEST";
export const LINKS_GET_LINKS_SUCCESSFUL = "LINKS_GET_LINKS_SUCCESSFUL";
export const LINKS_GET_LINKS_ERROR = "LINKS_GET_LINKS_ERROR";

export const SECURITY_GET_USER_REQUEST = "SECURITY_GET_USER_REQUEST";
export const SECURITY_GET_USER_SUCCESSFUL = "SECURITY_GET_USER_SUCCESSFUL";
export const SECURITY_GET_USER_ERROR = "SECURITY_GET_USER_ERROR";

export const ACTION_CLEAR_MAGIC_LINK = "ACTION_CLEAR_MAGIC_LINK";

export const ENUM_GET_VERBS_ERROR ="ENUM_GET_VERBS_ERROR";
